import React from "react";

// Platform shipment / ASN status (lowercase statuses from Firestore)
export function StatusBadge({ status }) {
    const cfg = {
        delivered:    { label:"✓ Delivered",   c:"bg-green-500/20  text-green-400  border-green-500/30" },
        completed:    { label:"✓ Completed",   c:"bg-green-500/20  text-green-400  border-green-500/30" },
        validated:    { label:"✓ Validated",   c:"bg-green-500/20  text-green-400  border-green-500/30" },
        approved:     { label:"✓ Approved",    c:"bg-cyan-500/20   text-cyan-400   border-cyan-500/30"  },
        in_transit:   { label:"↑ In Transit",  c:"bg-blue-500/20   text-blue-400   border-blue-500/30"  },
        on_water:     { label:"↑ On Water",    c:"bg-blue-500/20   text-blue-400   border-blue-500/30"  },
        submitted:    { label:"↑ Submitted",   c:"bg-blue-500/20   text-blue-400   border-blue-500/30"  },
        arrived:      { label:"↑ Arrived",     c:"bg-cyan-500/20   text-cyan-400   border-cyan-500/30"  },
        delayed:      { label:"↓ Delayed",     c:"bg-yellow-500/20 text-yellow-400 border-yellow-500/30"},
        exception:    { label:"⚠ Exception",   c:"bg-red-500/20    text-red-400    border-red-500/30"   },
        customs_hold: { label:"⚠ Customs Hold",c:"bg-red-500/20    text-red-400    border-red-500/30"   },
        rejected:     { label:"✗ Rejected",    c:"bg-red-500/20    text-red-400    border-red-500/30"   },
        cancelled:    { label:"✗ Cancelled",   c:"bg-red-500/20    text-red-400    border-red-500/30"   },
        draft:        { label:"○ Draft",       c:"bg-slate-700     text-slate-400  border-slate-600"    },
        pending:      { label:"○ Pending",     c:"bg-slate-700     text-slate-400  border-slate-600"    },
    }[status] || { label: status || "—", c:"bg-slate-700 text-slate-400 border-slate-600" };
    return (
        <span className={`px-2 py-0.5 rounded text-[10px] font-bold border whitespace-nowrap ${cfg.c}`}>
            {cfg.label}
        </span>
    );
}

// Excel report status (canonical codes from the ingestion service)
const EXCEL_STATUS_COLOR = {
    DELIVERED:"green", OUT_FOR_DELIVERY:"cyan", AWAITING_POD:"cyan", ARRIVED_BOOKED:"cyan", ARRIVED_AWAITING_BOOKING:"cyan",
    IN_TRANSIT:"blue", ALLOCATED_LINEHAUL:"blue", ALLOCATED_FOR_COLLECTION:"blue", AWAITING_COLLECTION:"blue",
    EXCEPTION_ASN:"red", UNKNOWN:"red",
};
const BADGE_CLASS = {
    green:"bg-green-500/20 text-green-400 border-green-500/30", cyan:"bg-cyan-500/20 text-cyan-400 border-cyan-500/30",
    blue:"bg-blue-500/20 text-blue-400 border-blue-500/30",     red:"bg-red-500/20 text-red-400 border-red-500/30",
    slate:"bg-slate-700 text-slate-400 border-slate-600",
};

export function ExcelStatusBadge({ code, raw, labels }) {
    const c = BADGE_CLASS[EXCEL_STATUS_COLOR[code] || "slate"];
    return (
        <span className={`px-2 py-0.5 rounded text-[10px] font-bold border whitespace-nowrap ${c}`} title={raw || ""}>
            {code === "UNKNOWN" ? (raw || "Unknown") : (labels[code] || code || "—")}
        </span>
    );
}

// Small coloured tag used in the shipment table's Flags column
export function Tag({ tone, title, children }) {
    const c = {
        amber: "bg-amber-500/15 text-amber-400",
        green: "bg-green-500/15 text-green-400",
        slate: "bg-slate-700 text-slate-400",
        red:   "bg-red-500/15 text-red-400",
    }[tone];
    return <span className={`px-1.5 py-0.5 rounded text-[10px] ${c} whitespace-nowrap`} title={title}>{children}</span>;
}
